/* Hatsy back-in-stock sheet: replaces the "Sold Out" button with "Notify me when available",
   registers the alert with Klaviyo Back in Stock and (if ticked) subscribes them to the newsletter. */
(function () {
  var sheet = document.getElementById('notify-sheet');
  var cfgEl = document.getElementById('ns-config');
  if (!sheet || !cfgEl) return;
  var cfg = {}; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
  var atc = document.getElementById('pdp-atc');
  var sticky = document.getElementById('pdp-sticky-atc');
  var notifyBtn = document.getElementById('pdp-notify');
  var lastFocus = null;

  /* ---------- which variant is selected ---------- */
  function currentVariantId() {
    var form = atc && atc.form;
    var input = form && form.querySelector('[name="id"]');
    return input ? input.value : null;
  }
  /* sold out = the button says Sold Out. A button that is only briefly switched off while a hat is being added is not sold out. */
  function soldOut() { return !!(atc && (/sold\s*out/i.test(atc.textContent) || (atc.disabled && atc.dataset.busy !== '1' && !/add|\u2713/i.test(atc.textContent)))); }

  /* ---------- swap Sold Out for Notify me ---------- */
  var lastState = null;
  function sync() {
    if (!atc || !notifyBtn) return;
    var out = soldOut();
    if (out === lastState) return;            /* only touch the page when the state actually changes */
    lastState = out;
    if (atc.hidden !== out) atc.hidden = out;
    if (notifyBtn.hidden !== !out) notifyBtn.hidden = !out;
    if (sticky) {
      if (out) { if (!sticky.dataset.nsLabel) sticky.dataset.nsLabel = sticky.textContent; sticky.dataset.nsNotify = '1'; sticky.textContent = 'Notify me'; }
      else if (sticky.dataset.nsNotify) { sticky.dataset.nsNotify = ''; if (sticky.dataset.nsLabel) sticky.textContent = sticky.dataset.nsLabel; }
    }
  }
  /* watch only what the theme changes on variant switch: the disabled flag and the button text */
  if (atc && 'MutationObserver' in window) new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
  sync();
  if (notifyBtn) notifyBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
  if (sticky) sticky.addEventListener('click', function (e) { if (sticky.dataset.nsNotify) { e.preventDefault(); e.stopImmediatePropagation(); open(); } }, true);

  /* ---------- scroll lock that works on iPhone and keeps the scroll position ---------- */
  var savedY = 0;
  function lockScroll() {
    savedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-savedY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlockScroll() {
    var b = document.body.style;
    var html = document.documentElement, prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';            /* the theme scrolls smoothly; restore instantly so the page doesn't bounce */
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, savedY);
    html.style.scrollBehavior = prev;
  }

  /* ---------- hide other apps' "notify me" buttons on the product page (only ours should show) ---------- */
  var area = (atc && (atc.closest('.pdp-wrap') || atc.closest('form') && atc.closest('form').parentElement)) || document.body;
  var OTHER = /notify\s*me|back\s*in\s*stock|email\s*me\s*when|restock/i;
  function hideOthers() {
    area.querySelectorAll('button, a, [role="button"], input[type="button"], input[type="submit"]').forEach(function (el) {
      if (el === notifyBtn || el === atc || el === sticky || el.closest('#notify-sheet') || el.closest('#pdp-sticky-bar') || el.hasAttribute('data-ns-hidden')) return;
      var txt = (el.value || el.textContent || '').trim();
      if (txt.length < 60 && OTHER.test(txt)) {
        var box = el;
        /* hide the app's wrapper too if it only holds this button */
        if (box.parentElement && box.parentElement !== area && box.parentElement.children.length === 1 && !box.parentElement.contains(notifyBtn) && !box.parentElement.contains(atc)) box = box.parentElement;
        box.setAttribute('data-ns-hidden', ''); el.setAttribute('data-ns-hidden', '');
        box.style.setProperty('display', 'none', 'important');
      }
    });
  }
  hideOthers();
  if ('MutationObserver' in window) {
    var hideTimer;
    new MutationObserver(function () { clearTimeout(hideTimer); hideTimer = setTimeout(hideOthers, 60); }).observe(area, { childList: true, subtree: true });
  }

  /* ---------- open / close ---------- */
  var chips = [].slice.call(sheet.querySelectorAll('.ns__chip'));
  var selected = null;
  function pickChip(c) {
    chips.forEach(function (x) { x.classList.toggle('is-on', x === c); });
    selected = c ? c.dataset.id : null;
    if (c && c.dataset.price) { var pr = sheet.querySelector('[data-ns-price]'); if (pr) pr.textContent = c.dataset.price; }
    if (c && c.dataset.img) { var im = sheet.querySelector('[data-ns-img]'); if (im) im.src = c.dataset.img; }
  }
  chips.forEach(function (c) { c.addEventListener('click', function () { pickChip(c); }); });
  function open() {
    lastFocus = document.activeElement;
    var vid = currentVariantId();
    var match = chips.filter(function (c) { return c.dataset.id === vid; })[0] || chips[0];
    if (chips.length) pickChip(match); else selected = vid;
    sheet.querySelector('[data-ns-form-view]').hidden = false;
    sheet.querySelector('[data-ns-done-view]').hidden = true;
    sheet.hidden = false; sheet.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    lockScroll();
    setTimeout(function () { var i = sheet.querySelector('[data-ns-email]'); if (i && window.innerWidth > 767) i.focus(); }, 300);
  }
  function close() {
    sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true');
    unlockScroll();
    setTimeout(function () { sheet.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  sheet.querySelectorAll('[data-ns-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
  /* swipe the sheet down to close (mobile) */
  var panel = sheet.querySelector('.ns__panel'), y0 = null;
  if (panel) {
  panel.addEventListener('touchstart', function (e) { if (panel.scrollTop <= 0) y0 = e.touches[0].clientY; }, { passive: true });
  panel.addEventListener('touchmove', function (e) { if (y0 !== null) { var d = e.touches[0].clientY - y0; if (d > 0) panel.style.transform = 'translateY(' + d + 'px)'; } }, { passive: true });
  panel.addEventListener('touchend', function (e) { if (y0 === null) return; var d = (e.changedTouches[0].clientY - y0); panel.style.transform = ''; y0 = null; if (d > 90) close(); });
  }

  /* ---------- email / SMS toggle ---------- */
  var channel = 'email';
  sheet.querySelectorAll('[data-ns-ch]').forEach(function (b) {
    b.addEventListener('click', function () {
      channel = b.dataset.nsCh;
      sheet.querySelectorAll('[data-ns-ch]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
      var em = sheet.querySelector('[data-ns-email]'), ph = sheet.querySelector('[data-ns-phone]');
      if (em) em.hidden = channel !== 'email'; if (ph) ph.hidden = channel !== 'sms';
      /* the newsletter box and email small print are email-only; texts get their own consent line */
      var nr = sheet.querySelector('[data-ns-news-row]'), fe = sheet.querySelector('[data-ns-fine-email]'), fs = sheet.querySelector('[data-ns-fine-sms]');
      if (nr) nr.hidden = channel !== 'email'; if (fe) fe.hidden = channel !== 'email'; if (fs) fs.hidden = channel !== 'sms';
      var focus = channel === 'sms' ? ph : em; if (focus && window.innerWidth > 767) focus.focus();
    });
  });

  /* ---------- Klaviyo ---------- */
  function klaviyoKey() {
    if (cfg.klaviyo_key) return cfg.klaviyo_key.trim();
    var s = document.querySelector('script[src*="klaviyo.com/onsite/js/"]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : '';
  }
   function backInStock(email, phone, variantId, marketing) {
    var key = klaviyoKey();
    if (!key) return Promise.reject(new Error('klaviyo-key'));
    var attrs = {}, channels = [];
    if (email) { attrs.email = email; channels.push('EMAIL'); }
    if (phone) {
      var d = String(phone).replace(/\D/g, '');
      if (d.length === 10) d = '1' + d;
      attrs.phone_number = '+' + d;
      channels.push('SMS');
    }
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: channels,
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      } })
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo-bis-' + r.status); });
  }
    function newsletter(email) {
    var key = klaviyoKey();
    if (!key) return;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Back in stock popup',
        profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { list: { data: { type: 'list', id: 'VvNzBE' } } }
      } })
    }).catch(function () {});
  }

  /* ---------- submit ---------- */
  var form = sheet.querySelector('[data-ns-form]'), err = sheet.querySelector('[data-ns-err]'), btn = sheet.querySelector('[data-ns-submit]');
  function fail(msg) { err.textContent = msg; err.hidden = false; }
  form.addEventListener('submit', function (e) {
    e.preventDefault(); err.hidden = true;
    var email = (sheet.querySelector('[data-ns-email]') || {}).value || '';
    var phoneEl = sheet.querySelector('[data-ns-phone]'), phone = phoneEl ? phoneEl.value.replace(/[^\d+]/g, '') : '';
    var vid = selected || currentVariantId();
    if (channel === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return fail('Please enter a valid email address.');
    if (channel === 'sms' && phone.replace(/\D/g, '').length < 10) return fail('Please enter a valid mobile number.');
    if (!vid) return fail('Please choose an option.');
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Saving\u2026';
    var news = sheet.querySelector('[data-ns-news]');
    backInStock(channel === 'email' ? email.trim() : '', channel === 'sms' ? (phone.charAt(0) === '+' ? phone : '+1' + phone.replace(/\D/g, '')) : '', vid, news && news.checked && channel === 'email')
      .then(function () {
        if (news && news.checked && channel === 'email') newsletter(email.trim());
        try { if (window.klaviyo && window.klaviyo.identify && channel === 'email') window.klaviyo.identify({ email: email.trim() }); } catch (x) {}
        sheet.querySelector('[data-ns-form-view]').hidden = true;
        sheet.querySelector('[data-ns-done-view]').hidden = false;
      })
      .catch(function () { fail('Sorry, something went wrong. Please try again.'); })
      .then(function () { btn.disabled = false; btn.textContent = label; });
  });
})();
